// removed by extract-text-webpack-plugin
module.exports = {"materialize-textarea":"style__materialize-textarea___1bqag","modal-2463794813":"style__modal-2463794813___1fKAI","container":"style__container___BhbsR","activeClass":"style__activeClass___2s8kK","tabViews":"style__tabViews___xRkca"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Admin/components/CollegeView/style.scss
// module id = 1560
// module chunks = 0